var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isPopWithDialog)?_c('div',{staticClass:"paper-bottom-download"},[_c('div',{staticClass:"paper-download-btn btn",attrs:{"data-io-click":"tracker"},on:{"click":_vm.handleDownload}},[_c('span',{staticClass:"download-paper-btn-text"},[_vm._v("免费下载")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }